import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Select2Multiple from 'v-select2-multiple-component';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import store from "@/store";
import { required } from 'vuelidate/lib/validators';

export default {
  name: "employeeList",
  components: {
    MainLayout,
    Loading,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    CONFIG,
  },

  data() {
    return {
      isFilterOpen: false,
      employees: [],
      employeeData: null,
      adminNo: store.state.user.admin_no,
      searchData: {
        search: "",
        employee_type: "",
        position_id: "",
        campus_name: "",
      },
      employeeTypeOptions: [
            { id: '', text: 'All' },
            { id: 'Staff', text: 'Staff' },
            { id: 'Teacher', text: 'Teacher' }
        ],
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      employee_flag: CONFIG.EMPLOYEE_FLAG,
      employeeFile: null,
      importType: CONFIG.EMPLOYEE_FLAG ? CONFIG.EMPLOYEE_FLAG.STAFF : 1,
      employeeFileName: '',
      invalidFile: false,
      submitted: false,
      disabled: false,
      role: CONFIG.ROLE.ID,
      leavedEmployeeData: {},
      CONFIG,
      positions: [],
    };
  },

  validations: {
    employeeFile: {
      required,
    },
  },

  computed: {
    positionOptions() {
      return this.positions.map(pos => ({
        id: pos.id,
        text: pos.position_name
      }));
    }
  },

  methods: {
    async getEmployees(page = 1) {
      this.isLoading = true;
      const typeMap = {
        Staff: CONFIG.EMPLOYEE_FLAG.STAFF,
        Teacher: CONFIG.EMPLOYEE_FLAG.TEACHER,
      };

      const employeeableType = typeMap[this.searchData.employee_type] || null;
      try {
        const res = await axios.get("/employee/list-paginated", {
          params: {
            page: page,
            search: this.searchData.search,
            employeeable_type: employeeableType,
            position_id: this.searchData.position_id || null,
            campus_name: this.searchData.campus_name || null,
          },
        });
        this.employeeData = res.data;
        this.employees = res.data?.data || [];
      } catch (error) {
        if (error.response && error.response.status == 401) {
          this.$store.commit("logout");
          window.location.replace("login");
        }
      } finally {
        this.isLoading = false;
      }
    },

    search() {
      this.getEmployees(1);
      this.getLeavedEmployeeList(1);
    },

    getLeavedEmployeeList(page = 1) {
      this.isLoading = true;
      const typeMap = {
        Staff: CONFIG.EMPLOYEE_FLAG.STAFF,
        Teacher: CONFIG.EMPLOYEE_FLAG.TEACHER,
      };
      const employeeableType = typeMap[this.searchData.employee_type] || null;
      axios.get("/employee/leavedList", {
        params: {
          page: page,
          leavedStatus: true,
          employeeable_type: employeeableType,
          position_id: this.searchData.position_id || null,
          search: this.searchData.search || null,
          campus_name: this.searchData.campus_name || null,
        }
      })
      .then((response) => {
        this.leavedEmployeeData = response.data;
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    reset() {
      this.searchData.search = "";
      this.searchData.employee_type = "";
      this.searchData.position_id = "";
      this.searchData.campus_name = "";
      this.positions = [];
      this.getEmployees(1);
      this.getLeavedEmployeeList(1);
    },

    isTeacher(emp) {
      return String(emp?.employeeable_type || "").includes("Teacher");
    },

    isAdmin(emp) {
      return String(emp?.employeeable_type || "").includes("Admin");
    },

    goEdit(empId) {
      this.$router.push({ path: `/employee/edit/${empId}` });
    },

    goDetail(empId) {
      this.$router.push({ path: `/employee/profile/${empId}` });
    },

    confirmDelete(empId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.delete(empId);
      }
    },

    async delete(empId) {
      this.isLoading = true;
      try {
        await axios.delete(`/employee/${empId}`);
        await this.getEmployees();
        await this.getLeavedEmployeeList();
        this.$notification.success("Employee Deleted Successfully", {
          timer: 3,
          position: "bottomCenter",
        });
      } catch (error) {
        if (error.response && error.response.status == 401) {
          this.$store.commit("logout");
          window.location.replace("login");
        }
      } finally {
        this.isLoading = false;
      }
    },

    login(id, campusId, status, name, role) {
      if (status == 1) {
        alert(name + ' is inactive.');
      }
      else {
        store.dispatch("loginByBtn", { loginId: id, campus_id: campusId, status: "web" })
          .then(() => {
            if (role === this.role.LIBRARY_ADMIN) {
              window.location.replace('/library/category');
            } else if (role === this.role.CLASS_MONITOR) {
              window.location.replace('/attendanceStudent/list');
            } else {
              window.location.replace('/');
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            this.isLoading = false;
          });
      }
    },

    templateDownload() {
      this.isLoading = true;
      axios.get('/employee/templateDownload', {
        params: {},
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'employee_import_template.xlsx');
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    chooseFile() {
      const fileUploader = this.$refs.fileUploader;

      fileUploader.setAttribute(
        'accept',
        '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );

      fileUploader.value = '';
      fileUploader.click();
    },

    onEmployeeFileChange() {
      this.invalidFile = false;
      const selectedFile = this.$refs.fileUploader.files;

      if (!selectedFile.length) {
          return;
      }

      const file = selectedFile[0];

      const isXlsx =
          file.name.toLowerCase().endsWith('.xlsx') ||
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      if (isXlsx) {
          this.employeeFileName = file.name;
          this.employeeFile = file;
      } else {
          this.invalidFile = true;
          this.employeeFileName = '';
          this.employeeFile = null;
          this.$refs.fileUploader.value = '';
      }

      this.disabled = false;
    },

    clearFile() {
      this.employeeFile = '';
      this.employeeFileName = '';
      document.getElementById('employee-upload').value = '';
      this.submitted = false;
      this.disabled = false;
      this.invalidFile = false;
    },

    importFile() {
      this.submitted = true;
      this.disabled = true;
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      } else {
        this.isLoading = true;
        let data = new FormData();
        data.append('employee_xlsx', this.employeeFile);
        data.append('campus_id', this.$store.state.user.campus_id);
        data.append('created_id', this.$store.state.user.id);
        axios.post("employee/importEmployee", data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          this.isLoading = false;
          if (response.data.success == true) {
            this.$notification.success(response.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
            this.disabled = false;
            this.getEmployees();
            this.getLeavedEmployeeList();
            this.clearFile();
          } else {
            this.isLoading = false;
            this.disabled = false;
            this.clearFile();
            alert(response.data.message);
          }
        }).catch((error) => {
          this.isLoading = false;
          this.disabled = false;
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
      }
    },

    async onEmployeeTypeChange() {
      this.searchData.position_id = "";
      this.positions = [];

      if (!this.searchData.employee_type) {
        return;
      }

      const typeMap = {
        Staff: CONFIG.EMPLOYEE_FLAG.STAFF,
        Teacher: CONFIG.EMPLOYEE_FLAG.TEACHER,
      };

      const typeValue = typeMap[this.searchData.employee_type];

      try {
        const response = await axios.get("/position/type", {
          params: {
            type: typeValue,
          },
        });
        this.positions = response.data || [];
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$store.commit("logout");
          window.location.replace("login");
        }
      }
    }
  },

  mounted() {
    this.getEmployees();
    this.getLeavedEmployeeList();
  },
};
